import { FC, useMemo } from 'react'
import { useParams, Navigate } from 'react-router-dom'
import { Box, CircularProgress } from '@mui/material'
import BackNavigationHeader, { BackNavigationContent } from 'components/BackNavigationHeader'
import PdfViewer from 'components/PdfViewer'
import { useDocumentsList } from 'services/documents/documents.hooks'

const Help: FC = () => {
  const { id } = useParams()
  const { data: attachmentsList = [], isFetching, isLoading } = useDocumentsList()

  const help = useMemo(
    () => attachmentsList.find((help) => help.id === Number(id)),
    [id, attachmentsList]
  )

  const parseMediaUrl = (url: string) => {
    const YOUTUBE_HOSTS = ['youtube.com', 'www.youtube.com', 'm.youtube.com']
    const VIDEO_ID_PATTERN = /^[\w-]{11}$/

    let parsedUrl: URL

    try {
      parsedUrl = new URL(url)
    } catch {
      return url
    }

    if (YOUTUBE_HOSTS.includes(parsedUrl.hostname)) {
      const videoId = parsedUrl.searchParams.get('v')

      if (videoId && VIDEO_ID_PATTERN.test(videoId)) {
        return `https://www.youtube.com/embed/${videoId}`
      }
    }

    return url
  }

  if (isFetching || isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <CircularProgress />
      </Box>
    )
  }

  if (help) {
    return (
      <>
        <BackNavigationHeader label={help.name} />
        <BackNavigationContent sx={{ position: 'relative' }}>
          <Box
            sx={{
              iframe: {
                height: 'calc(100vh - 200px)',
                border: 'none',
                width: 'calc(100vw - 2rem)'
              }
            }}
          >
            {help.file && <PdfViewer fileUrl={help.file} />}
            {help.movieUrl && (
              <iframe
                width='100%'
                height='auto'
                src={parseMediaUrl(help.movieUrl)}
                title={help.name}
                frameBorder='0'
                allow='accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
                allowFullScreen
              ></iframe>
            )}
          </Box>
        </BackNavigationContent>
      </>
    )
  }

  if (id) {
    return <Navigate to='/' />
  }

  return null
}

export default Help
